import { END, eventChannel } from 'redux-saga'

import { detectBrowser, detectOs, isLocalStorageAvailable } from 'app/utils/browser'
import { UPLOAD_FILE_URL } from 'app/utils/urls'
import { getUserToken, getUserTokenKey } from '../../utils/browser'
import { testValueWithRegex } from 'app/utils/regex'
import { EMAIL_REGEX, FULL_NAME_REGEX } from 'app/utils/regex'
import {
  getFileTypeIndex,
  getMessageType,
  // getFileSizeStringFromByte
} from 'app/utils/file'
import { FILE_TYPE_INDEX_TO_NAME, MAX_VALID_FILE_SIZES_BY_PACKAGE_INDEX } from 'app/constants/file'
import { playNotifSound } from 'app/utils/sound'
import {
  ADD_TO_ROOM_USER_URL,
  GET_MORE_CHATS_OF_CONVERSATION_URL,
  GET_USER_DATA_URL,
  RATE_CONVERSATION_QUALITY,
  SEND_MESSAGE_URL,
  SET_CONVERSATION_SEEN_BY_USER_URL,
  SUBMIT_FORM_DATA_URL,
  TALK_WITH_OPERATOR_INSTEAD_OF_BOT_URL,
  USER_TYPING_EVENT_URL,
} from 'app/constants/socketUrls'
import { DATA_OBJECT_KEY, OLD_USER_ID_KEY } from 'app/constants/localStorageKeys'
import { getHostWebsiteUrl } from 'app/utils/links'

// TODO: strongly believe that this file and the way flow is getting handled should get revised and refactored.

export var appLocalStorageObject = { raychat: {} }

// intial settings for local storage
appLocalStorageObject.init = function () {
  if (!localStorage.getItem(DATA_OBJECT_KEY)) {
    localStorage.setItem(DATA_OBJECT_KEY, JSON.stringify({}))
    if (getUserToken()) {
      this.setItem(OLD_USER_ID_KEY, getUserToken())
      this.setItem(getUserTokenKey(), getUserToken())
    }
  } else {
    this.raychat = JSON.parse(localStorage.getItem(DATA_OBJECT_KEY))
  }
}
appLocalStorageObject.getItem = function (key) {
  return this.raychat[key]
}
appLocalStorageObject.setItem = function (key, value) {
  this.raychat[key] = value
  this.update()
}

// updates and sets new raychat object and returns it
appLocalStorageObject.update = function () {
  return localStorage.setItem(DATA_OBJECT_KEY, JSON.stringify(this.raychat))
}
appLocalStorageObject.getObject = function () {
  return this.raychat
}
appLocalStorageObject.remove = function (key) {
  delete this.raychat[key]
  this.update()
}
appLocalStorageObject.removeAll = function () {
  this.raychat = {}
  this.update()
}

export const getUserIdFromLocalStorage = () => {
  if (!isLocalStorageAvailable()) {
    console.error('LocalStorage is blocked or unavailable')
    return null
  }

  try {
    return (
      appLocalStorageObject.getItem(getUserTokenKey()) ||
      localStorage.getItem(getUserTokenKey()) ||
      localStorage.getItem(OLD_USER_ID_KEY)
    )
  } catch (error) {
    console.error('LocalStorage access error:', error)
    return null
  }
}

function errorHandler(input) {
  if (
    input &&
    Object.prototype.hasOwnProperty.call(input, 'message') &&
    Object.prototype.hasOwnProperty.call(input, 'message_fa') &&
    Object.prototype.hasOwnProperty.call(input, 'success') &&
    Object.prototype.hasOwnProperty.call(input, 'status') &&
    Object.prototype.hasOwnProperty.call(input, 'type') &&
    input.success == false
  ) {
    if (input.data.field && input.data.message) {
      console.log({
        timeout: 3000,
        message: `${input.data.field}: ${input.data.message}`,
        position: 'topRight',
      })
    } else {
      console.log({
        timeout: 3000,
        message: input.message_fa || input.message,
        position: 'topRight',
      })
    }
    return false
  }
  return true
}

var visitorDetailsComplete = false
var checkUserInterval

const getAddToRoomData = ({ userId, channel_id, container_id }) => {
  return {
    user: {
      id: userId,
      name: appLocalStorageObject.getItem('clientName'),
      href: getHostWebsiteUrl(),
      channelId: channel_id,
      containerId: container_id,
    },
  }
}

export const checkForVisitorDetails = (socket, channel_id, container_id) => {
  if (visitorDetailsComplete) {
    const userIdSavedInLocalStorage = appLocalStorageObject.getItem(getUserTokenKey())
    // do stuff
    if (userIdSavedInLocalStorage) {
      const addToRoomData = getAddToRoomData({ channel_id, container_id, userId: userIdSavedInLocalStorage })

      socket.emit(
        'http',
        {
          method: 'post',
          url: ADD_TO_ROOM_USER_URL,
          data: addToRoomData,
        },
        (resData) => {
          if (!errorHandler(resData)) {
            return false
          }
        },
      )
    }
    clearInterval(checkUserInterval)
  } else {
    // waiting for response /newVisitor
  }
}

const createWidgetMessage = (chat) => {
  let widgetMessage = {
    isAutoMessage: false,
  }

  widgetMessage.content = chat.message
  widgetMessage.author = chat.meta.userId
  widgetMessage.type = getMessageType(chat.type, chat.message)
  widgetMessage.id = chat.id
  widgetMessage.conversationId = chat.conversationId
  widgetMessage.isAiBotMsg = chat.isBot
  if (chat?.edited) widgetMessage.edited = chat.edited
  if (chat?.replyId) widgetMessage.replyId = chat.replyId

  widgetMessage.createdAt = chat.createdAt

  if ((chat.type || chat.type === 0) && typeof chat.type === 'number') {
    widgetMessage.url = `${UPLOAD_FILE_URL}/${chat.message}`
    if (chat.meta.name) {
      widgetMessage.name = chat.meta.name
    }
    if (chat.meta.size) {
      widgetMessage.size = chat.meta.size
    }
    if (chat.meta.accessibleSize) {
      widgetMessage.accessibleSize = chat.meta.accessibleSize
    }
  }

  if (!chat.isAgent) {
    widgetMessage.me = true
  } else {
    widgetMessage.me = false
    if (chat.meta && (chat.meta.user_avatar || chat.meta.user_avatar == '')) {
      widgetMessage.avatar = chat.meta.user_avatar
    }
  }

  return widgetMessage
}

const getCurrentUserData = (responseData) => {
  delete responseData.agent
  delete responseData.channel
  delete responseData.chatCount
  delete responseData.lname
  delete responseData.type
  delete responseData.conversation
  delete responseData.success
  delete responseData.status

  return responseData
}

const getOperatorsInfo = (operatorId, operators) => {
  return operators.find((item) => item.id === operatorId)
}

// filters open conversations and returns with needed data
const handleOpenConversationsInNewVisit = (conversations, agents) => {
  const openConversations = []
  for (let conversation of conversations) {
    if (conversation.openConversation) {
      const agentInfo = getOperatorsInfo(conversation.openConversationAgentId, agents)
      openConversations.push({
        ...agentInfo,
        conversationId: conversation.openConversationId,
        teamId: conversation.teamId,
        meta: conversation.meta,
      })
    }
  }

  return openConversations
}

export const checkForNewVisitor = async ({
  socket,
  channel_id,
  container_id,
  forms,
  isOfficeHour,
  officeHours,
  notOfficeHours,
  operators,
}) => {
  let messages = []
  let openConversations = []
  const { mobile, os } = detectOs()
  const { name, ver } = detectBrowser()
  const href = getHostWebsiteUrl()
  const browserInfo = {
    name,
    os,
    mobile,
    ver,
    referrer: document.referrer,
  }
  const userIdInLocalStorage =
    appLocalStorageObject.getItem(getUserTokenKey()) || localStorage.getItem(getUserTokenKey())

  return new Promise((resolve) => {
    socket.emit(
      'http',
      {
        method: 'get',
        url: GET_USER_DATA_URL,
        data: {
          href,
          id: userIdInLocalStorage ?? undefined,
          browser: browserInfo,
          officeHours,
          notOfficeHours,
          sendForm: forms,
          channelId: channel_id,
        },
      },
      async (resData) => {
        if (!errorHandler(resData)) {
          return false
        }

        if (!resData.success) {
          appLocalStorageObject.removeAll()
        } else {
          appLocalStorageObject.setItem('clientName', resData.name)

          if (!userIdInLocalStorage) {
            const addToRoomData = getAddToRoomData({ channel_id, container_id, userId: resData.id })

            socket.emit(
              'http',
              {
                method: 'post',
                url: ADD_TO_ROOM_USER_URL,
                data: addToRoomData,
              },
              (resData) => {
                if (!errorHandler(resData)) {
                  return false
                }
              },
            )
          }

          // userId retrieved
          const userId = resData.id

          // there is no token OR current token is wrong
          if (!userIdInLocalStorage || userIdInLocalStorage + '' !== userId + '') {
            const userTokenKey = getUserTokenKey()
            appLocalStorageObject.setItem(userTokenKey, userId)
            localStorage.setItem(userTokenKey, userId)

            if (localStorage.getItem(userTokenKey) !== userId) {
              console.error('Failed to persist user ID!')
            }
          }

          visitorDetailsComplete = true

          const conversations = resData.conversation
          // conversation was made before
          if (conversations) {
            for (let conversation of conversations) {
              const renderedChatCount = conversation.chats.length
              const { teamId } = conversation

              if (renderedChatCount > 0) {
                // parent.raychat_data_fetched();

                conversation.chats = conversation.chats.reverse()
                // loop through all chats
                for (let i = 0; i < conversation.chats.length; i++) {
                  const chat = conversation.chats[i]
                  const adaptedMessage = createWidgetMessage(chat)
                  messages.push({
                    ...adaptedMessage,
                    teamId,
                    conversationId: chat.conversationId,
                  })
                }
              }
            }
          }

          if (conversations) {
            openConversations = handleOpenConversationsInNewVisit(resData.conversation, operators)
          }

          const forceGetUserDetails =
            isOfficeHour &&
            resData.offlineMessage &&
            resData.offlineMessage.active === 'true' &&
            forms?.form.forceGetUserDetails === 'true'

          resolve({
            rayToken: userId,
            user: getCurrentUserData(resData),
            chatCount: resData.chatCountByCov,
            messages,
            forceGetUserDetails,
            openConversations,
          })
        }
      },
    )
  })
}

export const sendNewMessage = ({
  socket,
  channelToken,
  content,
  moreData,
  replyId,
  tmpId,
  teamId,
  type,
  conversationId,
}) => {
  const userId = getUserIdFromLocalStorage()

  if (!userId) {
    console.error('Cannot send message - missing user ID')
  }

  return new Promise((resolve) => {
    socket.emit(
      'http',
      {
        method: 'post',
        url: SEND_MESSAGE_URL,
        data: {
          token: channelToken,
          id: userId,
          teamId,
          href: getHostWebsiteUrl(),
          msg: content,
          type,
          replyId,
          moreData,
          conversationId,
          tmpId,
        },
      },
      (resData) => {
        if (!errorHandler(resData)) {
          return false
        }
        playNotifSound('MSG_SENT')
        resolve(resData)
      },
    )
  })
}

export const getFormFields = (fields, texts) => {
  // these fields are temporary
  const NAME_FIELD = {
    type: 'name',
    placeholder: texts?.enter_your_name,
    label: texts?.enter_your_name,
  }

  const EMAIL_FIELD = {
    type: 'email',
    placeholder: texts?.enter_your_email,
    label: texts?.enter_your_email,
  }

  const PHONE_FIELD = {
    type: 'phone',
    placeholder: texts?.enter_your_phone_number,
    label: texts?.enter_your_phone_number,
  }

  switch (fields) {
    case 'name':
      return [NAME_FIELD]
    case 'email':
      return [EMAIL_FIELD]
    case 'numberName':
      return [NAME_FIELD, PHONE_FIELD]
    case 'name_phone':
      return [NAME_FIELD, PHONE_FIELD]
    case 'phone':
      return [PHONE_FIELD]
    case 'both':
      return [EMAIL_FIELD, PHONE_FIELD]
    case 'allThree':
      return [NAME_FIELD, EMAIL_FIELD, PHONE_FIELD]
    default:
      break
  }
}

export const getFormDataToCreateFormMessage = (apiData, texts) => {
  const form = apiData?.form
  const offlineMessage = apiData?.offlineMessage

  const fieldNamesKey = form?.fieldName
  const isFormTitleActive = offlineMessage.active

  const formTitle = isFormTitleActive ? offlineMessage.message : ''
  const formFields = getFormFields(fieldNamesKey, texts)

  return { formTitle, formFields }
}

export const createOperatorMessage = (operatorMessage) => {
  const adaptedMessage = {
    me: false,
    avatar: operatorMessage.agent_avatar,
    isAutoMessage: false,
    createdAt: operatorMessage.messageObj.createdAt,
  }

  adaptedMessage.type = getMessageType(operatorMessage.messageObj.type, operatorMessage.message)
  adaptedMessage.content = operatorMessage.message
  adaptedMessage.url = `${UPLOAD_FILE_URL}/${operatorMessage.message}`
  adaptedMessage.conversationId = operatorMessage.conversationId || operatorMessage?.messageObj?.conversationId
  adaptedMessage.id = operatorMessage.chatId
  adaptedMessage.author = operatorMessage.agent_id
  adaptedMessage.isAiBotMsg = operatorMessage.isBot

  if (operatorMessage?.edited) adaptedMessage.edited = operatorMessage.edited
  if (operatorMessage?.replyId) adaptedMessage.replyId = operatorMessage.replyId
  if (operatorMessage?.reply) adaptedMessage.replyId = operatorMessage.reply.replyId

  if (operatorMessage.messageObj && operatorMessage.messageObj !== 'undefined') {
    if (
      (operatorMessage.messageObj.type || operatorMessage.messageObj.type === 0) &&
      typeof operatorMessage.messageObj.type === 'number'
    ) {
      adaptedMessage.name = operatorMessage.messageObj.meta.name
      adaptedMessage.size = operatorMessage.messageObj.meta.size
    }
  }

  return adaptedMessage
}

export const createAcceptedStatusMessage = (agent) => {
  return {
    type: 'accept_status',
    agent,
    me: null,
    createdAt: new Date(),
  }
}

export const createClosedStatusMessage = () => {
  return {
    me: null,
    type: 'close_status',
    createdAt: new Date(),
  }
}

export const getAcceptedChatInfo = (statusMessage) => {
  const { teamId } = statusMessage

  return {
    status: true,
    agentInfo: { ...statusMessage },
    teamId,
  }
}

export const createTriggerMessage = (message, operator) => {
  const triggerMessage = {
    message: message.message,
    agent_id: message.agent_id,
    avatar: message.agent_avatar,
    isAutoMessage: false,
    teamId: message.teamId || null,
    sender: { id: message.agent_id, title: operator?.name },
  }

  return triggerMessage
}

// fileSize in bytes
export const isFileSizeValidAccordingToPackage = (fileSize, packageIndex) => {
  const max = MAX_VALID_FILE_SIZES_BY_PACKAGE_INDEX[packageIndex]

  const sizeInMb = Math.round(fileSize / Math.pow(1024, 2), 2)

  return sizeInMb <= max
}

export const getFileData = (file) => {
  let fileTypeIndex = getFileTypeIndex(file.type)
  const fileData = window.URL.createObjectURL(file)

  const typeName = FILE_TYPE_INDEX_TO_NAME[fileTypeIndex]

  return {
    file,
    fileData,
    fileType: fileTypeIndex,
    type: typeName,
    size: file.size,
    name: file.name,
  }
}

export const createFileMessage = (message) => {
  let isSending = !message.file?.id

  let fileMessage = {
    status: isSending ? 'pending' : 'seen',
    type: message.type,
    url: message.fileData,
    me: true,
    name: message.name,
    size: message.size,
    isAutoMessage: false,
  }

  fileMessage.tmpId = Math.random().toString(36).substring(7)

  if (message?.replyId) fileMessage.replyId = message.replyId

  return fileMessage
}

export function sendMedia({ fileId, type, tmpId, moreData, socket, token, teamId, replyId }) {
  let neededData = {
    token: token,
    id: appLocalStorageObject.getItem(getUserTokenKey()),
    href: getHostWebsiteUrl(),
    msg: fileId,
    moreData: moreData,
    tmpId: tmpId,
    type,
    teamId,
  }

  if (replyId) neededData['replyId'] = replyId

  return new Promise((resolve) => {
    socket.emit(
      'http',
      {
        method: 'post',
        url: SEND_MESSAGE_URL,
        data: neededData,
      },
      (resData) => {
        if (!errorHandler(resData)) {
          return false
        }
        if (resData.status === 2) {
          resolve('showForm')
        } else {
          playNotifSound('MSG_SENT')
          resolve(resData)
        }
      },
    )
  })
}

export const uploadFile = (file, fileType, fileData, tmpId, socket, token, teamId, replyId, languageInfo) => {
  let emit // this emitter is used to put upload percentage into the channel.

  const channel = eventChannel((emitter) => {
    emit = emitter
    return () => {}
  })

  const uploadPromise = () =>
    new Promise((resolve, reject) => {
      const type = fileType

      var formData = new FormData()

      formData.append('uploader', appLocalStorageObject.getItem(getUserTokenKey()))
      formData.append('file', file) // file.name
      var xhr = new XMLHttpRequest()

      xhr.upload.onloadstart = function () {
        emit(0)
      }

      xhr.upload.onprogress = function (e) {
        const percentComplete = (e.loaded / e.total) * 100
        emit(percentComplete.toFixed(0))
      }

      xhr.open('POST', `${UPLOAD_FILE_URL}/upload`, true)
      xhr.send(formData)

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var response = JSON.parse(xhr.responseText)
          if (response && response.success) {
            let moreData = {
              name: response.name,
              size: response.size,
            }
            if (type === 0) {
              moreData.accessibleSize = response.formats
            }

            // COMMENT-ALI : file uploaded successfully.

            resolve(
              new Promise((resolve) => {
                resolve({
                  responseId: response.id,
                  type,
                  tmpId,
                  moreData,
                  fileType,
                  socket,
                  token,
                  teamId,
                  replyId,
                  file,
                })
              }),
            )

            emit(END)
          }

          return
        }

        if (xhr.readyState === 4 && xhr.status > 299) {
          reject({
            type: 'MANUAL_REJECT_UPLOAD_ERROR',
            errMessage: languageInfo.texts?.fileUploadServerError,
            tmpId,
            teamId,
          })
          emit(-1)
          emit(END)
        }
      }

      xhr.onerror = function () {
        reject({
          type: 'MANUAL_REJECT_UPLOAD_ERROR',
          errMessage: languageInfo.texts?.uploadFailedTryAgain,
          tmpId,
          teamId,
        })
        // alert(languageInfo.texts?.uploadFailedTryAgain);
        emit(-1)
        emit(END)
      }
    })

  return [uploadPromise, channel]
}

const getAdaptedFormDataForDynamicForms = (data) =>
  data.map((item) => {
    const isSpecial = ['phone', 'name', 'email'].includes(item.type)

    const name = isSpecial ? item.type : item.placeholder

    return {
      name,
      value: item.value,
    }
  })

export const submitDynamicUserFormData = (socket, data) => {
  const formData = getAdaptedFormDataForDynamicForms(data.formInputs)

  return new Promise(
    (resolve) => {
      socket.emit(
        'http',
        {
          method: 'post',
          url: SUBMIT_FORM_DATA_URL,
          data: {
            channelId: data.channelId,
            // userId
            id: appLocalStorageObject.getItem(getUserTokenKey()),
            teamId: data.teamId,
            metadata: formData,
          },
        },
        (resData) => {
          if (!errorHandler(resData)) {
            return false
          }
          resolve(resData)
        },
      )
    },
    // eslint-disable-next-line no-unused-vars
    (error) => ({ success: false }),
  )
}

export const sendNewWord = (socket, { message, operatorId, channelId, conversationId }) => {
  if (!conversationId) return

  if (message === undefined || !operatorId) return

  // NOTE: even when no conversation is accepted this will be fired. consider when refactoring.
  socket.emit(
    'http',
    {
      method: 'post',
      url: USER_TYPING_EVENT_URL,
      data: {
        channelId,
        agentId: operatorId,
        msg: message,
        conversationId,
      },
    },
    (resData) => {
      if (!errorHandler(resData)) {
        return false
      }
    },
  )
}

export const fetchMessages = (socket, { page, conversationId, teamId }) => {
  const id = appLocalStorageObject.getItem(getUserTokenKey())

  return new Promise((resolve) => {
    socket.emit(
      'http',
      {
        method: 'get',
        url: GET_MORE_CHATS_OF_CONVERSATION_URL,
        data: {
          conversationId,
          id,
          teamId,
          page,
        },
      },
      (resData) => {
        if (!errorHandler(resData)) {
          return false
        }
        let messages = []
        resData.chats.forEach((chat) => {
          messages.push(createWidgetMessage(chat))
        })
        resolve(messages.reverse())
      },
    )
  })
}

export const submitFeedbackToServer = ({ socket, data }) => {
  const { agentId, conversationId, rate, comment } = data
  let uId = appLocalStorageObject.getItem(getUserTokenKey())

  if (agentId && uId && conversationId) {
    let data = {
      agentId,
      uId,
      conversationId,
      emotion: rate || undefined,
      comment: comment || undefined,
    }

    return new Promise((resolve) => {
      socket.emit(
        'http',
        {
          method: 'post',
          url: RATE_CONVERSATION_QUALITY,
          data,
        },
        (resData) => {
          if (!errorHandler(resData)) {
            return false
          }
          resolve(true)
        },
      )
    })
  }
}

export const handleRemoveNotSeenConversation = (socket, conversationId) => {
  return new Promise((resolve) => {
    socket.emit(
      'http',
      {
        method: 'post',
        url: SET_CONVERSATION_SEEN_BY_USER_URL,
        data: {
          conversationId,
          isWidget: true,
        },
      },
      (resData) => {
        resolve(resData)
      },
    )
  })
}
export const createGroupMessage = (message) => ({
  me: false,
  avatar: null,
  type: 'text',
  content: message,
  isAutoMessage: true,
  createdAt: new Date(),
})

/*
 * This function checks if form fields are submited before and if fields are already submited then there is no need to show the form message
 *  @param {object} user
 *  @param {string[]} fieldkey - field name key
 *  @return {boolean} - should show form message?
 */
export const isThereAnyUnfilledFieldInForm = (user, fieldkeys) => {
  const shouldShow = fieldkeys.some((item) => {
    const { type } = item

    if (type === 'email')
      return !user.email || user.email.endsWith('@raychat.ir') || !testValueWithRegex(EMAIL_REGEX, user.email)

    if (type === 'phone') return !user['phone']

    if (type === 'name') return !user.name || !testValueWithRegex(FULL_NAME_REGEX, user.name)

    return !user.info?.find((customInfoItem) => customInfoItem.name === item.label)
  })

  return shouldShow
}

/**
 * This function gets package settings retrieved from widget response and returns an object with all accesses according to the user's package type
 *
 * @param {object} packSettings
 */
export const getWidgetFeatureAccessObject = (packSettings) => ({
  disableRayChatLogo: packSettings.disableRayChatLogo,
  responseBot: packSettings.botResponser,
  customLogo: packSettings.customeLogo,
  autoMessage: packSettings.trigger,
  lingers: packSettings.waitingForm,
  seeTypingWords: packSettings.realTimeUserTypedMessage,
  sendVoiceMsg: packSettings.sendVoiceWidget,
  uploadFileLimit: packSettings.mediaUploadLimit.widget,
})

export const handleTalkWithOperator = (socket, data) => {
  return new Promise((resolve) => {
    socket.emit(
      'http',
      {
        method: 'post',
        url: TALK_WITH_OPERATOR_INSTEAD_OF_BOT_URL,
        data,
      },
      (resData) => {
        resolve(resData)
      },
    )
  })
}

export const getUploadFileError = ({ languageInfo, fileType, fileSize, packageIndex }) => {
  const invalidFileExtensionErrorMsg = languageInfo.texts.invalidFileExtension
  const largeFileErrorMsg = languageInfo.texts.largeFile

  const typeIndex = getFileTypeIndex(fileType)

  const isFileSizeValid = isFileSizeValidAccordingToPackage(fileSize, packageIndex)

  if (typeIndex === -1) return invalidFileExtensionErrorMsg

  if (!isFileSizeValid) return largeFileErrorMsg
}
